<template>
  <ol class="breadcrumb">
    <li
      v-for="(item, index) in list"
      :key="index"
      class="breadcrumb-item"
      style="line-height: 26px"
    >
      <span
        v-if="isLast(index)"
        class="active"
      >
        {{ showName(item) }}
      </span>
      <router-link
        v-else
        :to="item"
      >
        {{ showName(item) }}
      </router-link>
    </li>
    <li class="ml-auto">
        <b-form-group class="mb-0">
            <b-input-group>
                <!-- <b-form-input type="text" id="search" size="sm" class="pb-0 pt-0" placeholder="Search"/> -->
                <vue-autosuggest
                    :suggestions="search.suggestions"
                    :input-props="{id:'autosuggest__input', placeholder:'Search', class:'col-12'}"
                    :render-suggestion="renderSuggestion"
                    :get-suggestion-value="getSuggestionValue"
                    :section-configs="search.sectionConfigs"
                    @input="onInputChange"
                    style="border: 1px solid #c2cfd6; line-height: 1.5"
                >
                </vue-autosuggest>
            </b-input-group>
        </b-form-group>
    </li>
  </ol>
</template>

<script>
import AlbumAPI from '../../../api/album.js'
import TrackAPI from '../../../api/track.js'

export default {
    props: {
        list: {
            type    : Array,
            required: true,
            default : () => [],
        },
    },
    methods: {
        isLast (index) {
            return index === this.list.length - 1
        },
        showName (item) {
            if (item.meta && item.meta.label)
            item = item.meta && item.meta.label

            if (item.name)
            item = item.name

            return item
        },
        onInputChange(text) {
            var vm = this
            // event fired when the input changes
            clearTimeout(this.search.timeout);
            this.search.timeout = setTimeout(() => {
                const albumsPromise = AlbumAPI.getAlbumList();
                const tracksPromise = TrackAPI.getTrackList();

                Promise.all([albumsPromise, tracksPromise]).then(values => {
                    vm.search.suggestions = [];
                    //vm.search.selected = null;

                    const albums = vm.filterResults(values[0].data.album_list, text, "english_title");
                    const tracks = vm.filterResults(values[1].data.track_list, text, "english_title");

                    albums.length &&
                    vm.search.suggestions.push({ name: "albums", data: albums });
                    tracks.length &&
                    vm.search.suggestions.push({ name: "tracks", data: tracks });
                });
            }, vm.search.debounceMilliseconds);
        },
        filterResults(data, text, field) {
            let filteredData = data
            .filter(item => {
                if (item[field].toLowerCase().indexOf(text.toLowerCase()) > -1) {
                    return item[field];
                }
            }).sort()
            return filteredData
        },
        renderSuggestion(suggestion) {
            return suggestion.item.english_title;
        },
        getSuggestionValue(suggestion) {
            let { name, item } = suggestion;
            return item.english_title;
        }
    },
    data() {
        return {
            search: {
                        suggestions: [],
                        timeout: null,
                        debounceMilliseconds: 50,
                        //selected: null,
                        sectionConfigs: {
                            albums: {
                                limit: 6,
                                label: "Album",
                                onSelected: selected => {
                                    this.$router.push({
                                                        path: `/albums/${selected.item.id}`,
                                                    })
                                }
                            },
                            tracks: {
                                limit: 6,
                                label: "Track",
                                onSelected: selected => {
                                    this.$router.push({
                                                        path: `/tracks/${selected.item.id}`,
                                                    })
                                }
                            }
                        }
            },
        }
    }
}
</script>

<style>
.autosuggest__results-container {
  position: relative;
  width: 100%;
}

.autosuggest__results {
  font-weight: 300;
  margin: 0;
  position: absolute;
  z-index: 10000001;
  width: 100%;
  border: 1px solid #e0e0e0;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  background: white;
  padding: 0px;
  max-height: 400px;
  overflow-y: scroll;
}

.autosuggest__results ul {
  list-style: none;
  padding-left: 0;
  margin: 0;
}

.autosuggest__results .autosuggest__results-item {
  cursor: pointer;
  padding: 15px;
}

#autosuggest ul:nth-child(1) > .autosuggest__results {
  border-top: none;
}

.autosuggest__results .autosuggest__results-before {
  color: gray;
  font-size: 11px;
  margin-left: 0;
  padding: 15px 13px 5px;
  border-top: 1px solid lightgray;
}

.autosuggest__results .autosuggest__results-item:active,
.autosuggest__results .autosuggest__results-item:hover,
.autosuggest__results .autosuggest__results-item:focus,
.autosuggest__results .autosuggest__results-item.autosuggest__results-item-highlighted {
  background-color: #f6f6f6;
}
</style>
